// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1qG4C","signatureBlock":"Footer_signatureBlock__1Ohis","signature":"Footer_signature__I6Fqm"};